import { AuthCallback, RequireAuth, RequireNoAuth } from '@psyomics/ui-common';
import { GenericError, BackgroundLayout, BackgroundRouteConfig } from '@psyomics/ui-components';
import { Route, Routes } from 'react-router-dom';

import { HeaderIllustrationLayout } from '../shared/components/header-illustration-layout/header-illustration-layout';
import { InsecureLayout } from '../shared/components/insecure-layout/insecure-layout';
import { MobileLayout } from '../shared/components/mobile-layout/mobile-layout';
import { SecureLayout } from '../shared/components/secure-layout/secure-layout';

import { About } from './routes/about/about';
import { Account } from './routes/account/account';
import { ChangePassword } from './routes/account/change-password';
import { ChangePasswordSuccess } from './routes/account/change-password-success';
import { ConfirmForgotPassword } from './routes/forgot-password/confirm-forgot-password';
import { ForgotPassword } from './routes/forgot-password/forgot-password';
import { ForgotPasswordSuccess } from './routes/forgot-password/success';
import { Home } from './routes/home/home';
import { MfaSetup } from './routes/mfa-setup/mfa-setup';
import { RequireMfaSetup } from './routes/mfa-setup/require-mfa-setup';
import Questionnaire from './routes/questionnaire/questionnaire';
import { Referral } from './routes/referral/referral';
import { SelfReferral, SelfReferralInit } from './routes/self-referral/self-referral';
import { SelfReferralRedirect } from './routes/self-referral/self-referral-redirect';
import { SmsOptout } from './routes/sms-opt-out/sms-opt-out';
import { SmsOptOutSuccess } from './routes/sms-opt-out-success/sms-opt-out-success';
import { SelfHostedLogin } from './self-hosted-login';
import { SelfHostedRegister } from './self-hosted-register';

const getIndexRoute = () => '/';
const getLoginRoute = () => '/login';
const forgotPasswordRoute = '/forgot-password';

const AuthRoutes = () => (
  <Routes>
    <Route Component={BackgroundLayout}>
      <Route Component={AuthCallback} path="/auth/callback" />
      <Route Component={SelfReferralRedirect} path="/self-referral/redirect" />
      <Route Component={InsecureLayout}>
        <Route Component={SelfReferral} path="/self-referral/:selfReferralCode" />
      </Route>
      <Route element={<RequireNoAuth getIndexRoute={getIndexRoute} />}>
        <Route Component={InsecureLayout}>
          <Route Component={SmsOptout} path="/sms-opt-out" />
          <Route Component={SmsOptOutSuccess} path="/sms-opt-out-success" />
          <Route Component={MobileLayout}>
            <Route Component={Referral} path="/referral/:invitePublicId/*" />
            <Route Component={SelfHostedRegister} path="/register" />
            <Route Component={ForgotPassword} path={forgotPasswordRoute} />
            <Route Component={ConfirmForgotPassword} path={`${forgotPasswordRoute}/confirm`} />
            <Route Component={ForgotPasswordSuccess} path={`${forgotPasswordRoute}/success`} />
          </Route>
          <Route Component={HeaderIllustrationLayout}>
            <Route Component={MobileLayout}>
              <Route element={<SelfHostedLogin forgotPasswordUrl={forgotPasswordRoute} />} path="/login" />
            </Route>
          </Route>
          <Route element={<GenericError titleKey="common.errors.notFound" />} path="/*"></Route>
        </Route>
      </Route>

      <Route element={<RequireAuth getLoginRoute={getLoginRoute} />}>
        <Route element={<RequireMfaSetup />}>
          <Route Component={SecureLayout}>
            <Route Component={MobileLayout}>
              <Route element={<BackgroundRouteConfig variant="purpleGreen" />}>
                <Route Component={Home} index />
              </Route>
              <Route Component={MfaSetup} path="mfa-setup" />
              <Route Component={SelfReferralInit} path="/self-referral/init/:selfReferralCode" />
              <Route Component={Questionnaire} path="/questionnaire/:id/*" />
              <Route Component={Account} path="account" />
              <Route Component={ChangePassword} path="account/change-password" />
              <Route Component={ChangePasswordSuccess} path="account/change-password-success" />
              <Route Component={About} path="about" />
              <Route element={<GenericError titleKey="common.errors.notFound" />} path="/*"></Route>
            </Route>
          </Route>
        </Route>
      </Route>
    </Route>
  </Routes>
);

export { AuthRoutes };
